window.addEventListener('DOMContentLoaded',() => {
  var swatCustomerLists = null;

  function initLists(swat){
    swat.fetchLists({
      callbackFn: function(lists){
        swatCustomerLists = lists;
        initWishlistButton();
      }
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(initLists);

  class WishlistButton extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.modal = null;
      this.handle = null;
      this.closeBtns = null;
      this.addBtn = null;
      this.createWrapper = null;
      this.createInput = null;
      this.createBtn = null;
      this.createForm = null;
      this.type = this.dataset.type;
      this.listId = this.dataset.list;
      this.product = null;
      this.init();
    }

    updateData(){
      this.handle = this.dataset.handle;
      this.product = {
        epi: parseInt(this.dataset.variant),
        empi: parseInt(this.dataset.product),
        du: `https://${Shopify.shop}/products/${this.handle}`
      }
      this.updateState();
    }

    updateState(){
      let inLists = 0;
      const ariaLabel = this.getAttribute('aria-label');
      let newAriaLabel = '';
      if(this.type == 'list'){ // wishlist page
        this.classList.add('active');
        newAriaLabel = this.updateAriaLabel(true,ariaLabel);
      } else {
        swatCustomerLists.forEach((list) => {
          let exists = this.existsInList(list);
          if(exists){
            inLists++;
          }
        });

        if(inLists != 0 && inLists == swatCustomerLists.length){ // already in all lists
          this.classList.add('active');
          newAriaLabel = this.updateAriaLabel(true,ariaLabel);
        } else {
          this.classList.remove('active');
          newAriaLabel = this.updateAriaLabel(false,ariaLabel);
        }
      }
      if(newAriaLabel != ''){
        this.setAttribute('aria-label',newAriaLabel);
      }
    }

    updateAriaLabel(active,text){
      if(active){
        text = text.replace('Add ','Remove ').replace('to a wishlist','from a wishlist');
      } else {
        text = text.replace('Remove ','Add ').replace('from a wishlist','to a wishlist');;
      }
      return text;
    }

    existsInList(list){
      let inList = false;
      let prodOrVariant = (this.type == 'product') ? 'empi' : 'epi';
      var listItemIDs = list.listcontents.map(item => item[prodOrVariant]);
      if(listItemIDs.includes(this.product[prodOrVariant])){
        inList = true;
      }
      return inList;
    }

    init(){
      this.updateData();
      this.classList.remove('u-visually-hidden');
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(){
      const self = this;
      this.updateData();
      if(this.classList.contains('active')){
        this.deleteItemModal();
      } else {
        this.updateCustomerLists(function(){
          if(swatCustomerLists.length == 0){
            window._swat.createList({"lname": "My Wishlist"},function(){
              self.updateCustomerLists(function(){
                self.buildModal();
              });
            });
          } else {
            self.buildModal();
          }
        });
      }
    }

    deleteItemModal(){
      var self = this;
      fetch('/pages/wishlist', {credentials: 'same-origin', method: 'GET'})
      .then(response => response.text()).then(data => {
        var html = hwDOMParser.parseFromString(data, 'text/html');
        const deleteModal = html.getElementById('wishlist-modal-edit-delete');
        if(deleteModal){
          const deleteMsg = html.getElementById('wishlist-modal-delete-msg');
          if(deleteMsg){
            deleteMsg.textContent = 'Removing a wishlist item cannot be undone.'
            deleteMsg.removeAttribute('id');
          }
          const deleteSubmit = html.getElementById('wishlist-delete-submit');
          if(deleteSubmit){
            deleteSubmit.textContent = 'Remove item'
            deleteSubmit.setAttribute('id','wishlist-delete-item');
          }
          deleteModal.setAttribute('id','wishlist-modal-delete-item');
          document.body.appendChild(deleteModal);
          const newDeleteModal = document.getElementById('wishlist-modal-delete-item');
          newDeleteModal.classList.remove('hide');
          hwTrapFocus(newDeleteModal);
          newDeleteModal.querySelectorAll('.wishlist-modal__close').forEach((btn) => {
            btn.addEventListener('click',() => {
              self.closeDeleteModal(newDeleteModal);
            });
          });
          document.getElementById('wishlist-delete-item').addEventListener('click',() => {
            const listContent = document.getElementById(`list-content-${self.listId}`);
            if(listContent){
              const listIDs = [self.listId];
              self.removeFromLists(listIDs,true,listContent);
            } else {
              const listIDs = swatCustomerLists.map((list) => list.lid);
              self.removeFromLists(listIDs,false);
              self.classList.remove('active');
            }
            self.closeDeleteModal(newDeleteModal);
          });
        }
      });
    }

    closeDeleteModal(modal){
      hwCancelTrapFocus(modal);
      modal.remove();
      this.focus();
    }

    removeFromLists(listIDs,removeCard,listContent){
      const self = this;
      window._swat.removeProductFromLists(self.product, listIDs, function(){
        if(removeCard){
          const card = listContent.querySelector(`[data-id="${self.product.epi}"]`);
          if(card){
            card.remove();
          }
          if(listContent.querySelector(`.Grid`).childElementCount == 0){
            listContent.innerHTML = `<div class="Alert Alert--error mb-20">This list has no items yet!</div><a href="/" class="Button Button--black">Start Shopping</a>`;
          }
          self.updateCustomerLists();
        } else {
          self.updateCustomerLists(function(){
            self.updateState();
          });
        }
      });
    }

    updateCustomerLists(callback){
      window._swat.fetchLists({
        callbackFn: function(lists){
          swatCustomerLists = lists;
          if(typeof callback == 'function'){
            callback();
          }
        }
      });
    }

    buildModal(){
      let listsHTML = '';
      swatCustomerLists.forEach((list) => {
        let exists = this.existsInList(list);
        listsHTML += this.listCheckbox(list.lid,list.lname,exists);
      });
      if(listsHTML != ''){
        fetch(`/products/${this.handle}?variant=${this.product.epi}&view=ajax.wishlist-modal`).then(response => response.text()).then(data => {
          const self = this;
          const html = hwDOMParser.parseFromString(data, 'text/html');
          const modalEl = html.getElementById('wishlist-modal-overlay');
          document.body.appendChild(modalEl);
          const listsEl = document.getElementById('customer-wishlists');
          const loginLink = document.getElementById('wishlist-modal-login');
          listsEl.innerHTML = listsHTML;
          self.modal = document.getElementById('wishlist-modal-overlay');
          self.closeBtns = self.modal.querySelectorAll('.wishlist-modal__close');
          self.createWrapper = document.getElementById('create-wishlist');
          if(loginLink){
            var link = loginLink.getAttribute('href');
            var newLink = link + '?return_to=' + encodeURIComponent(window.location.pathname);
            loginLink.setAttribute('href',newLink);
          }
          if(swatCustomerLists.length >= 10){
            self.createWrapper.classList.add('hide');
          }
          self.openModal();
          self.initModalEvents();
        });
      }
    }

    listCheckbox(id,name,selected){
      return `<input class="customer-wishlist__input u-visually-hidden" id="list-${id}" type="checkbox" value="${id}" data-name="${name}"${selected ? 'checked disabled' : ''}>
        <label for="list-${id}" class="customer-wishlist Flex Flex--center-align">
          <span class="customer-wishlist__checkbox bg-color--white display-block relative">
            <svg role="presentation" viewBox="0 0 24 24"><polygon fill="#001D34" points="9,20 2,13 5,10 9,14 19,4 22,7 "></polygon></svg>
          </span>
          <span class="customer-wishlist__title">${name}</span>
        </label>`;
    }

    toggleBtnState(btn,disable){
      if(disable){
        btn.setAttribute('disabled','true');
      } else {
        btn.removeAttribute('disabled');
      }
    }

    initCheckboxEvent(input,isNew){
      input.addEventListener(('change'),() => {
        const checkedInputs = document.querySelectorAll('.customer-wishlist__input:checked');
        const disableBtn = (checkedInputs.length == 0);
        this.toggleBtnState(this.addBtn,disableBtn);
      });
      if(isNew){
        input.focus();
      }
    }

    initModalEvents(){
      const self = this;
      self.addBtn = document.getElementById('add-to-wishlists');
      self.createInput = document.getElementById('create-wishlist-name');
      self.createBtn = document.getElementById('create-wishlist-submit');
      self.createForm = document.getElementById('create-wishlist-form');

      document.querySelectorAll('.customer-wishlist__input').forEach((input) => {
        self.initCheckboxEvent(input);
      });

      self.addBtn.addEventListener('click',() => {
        self.addToLists();
      });

      self.createInput.addEventListener('keyup',() => {
        var disable = false;
        var swatListNames = swatCustomerLists.map((list) => {return list.lname});
        if(self.createInput.value == ''){
          self.createInput.setCustomValidity('A list name is required.');
          disable = true;
        } else if(swatListNames.indexOf(self.createInput.value) !== -1){
          self.createInput.setCustomValidity('A list with this name already exists.');
          disable = true;
        } else {
          self.createInput.setCustomValidity('');
        }
        self.createInput.reportValidity();
        self.toggleBtnState(self.createBtn,disable);
      });

      self.createForm.addEventListener('submit',(e) => {
        e.preventDefault();
        const name = document.getElementById('create-wishlist-name').value;
        self.createListForModal(name);
      });

      self.closeBtns.forEach((btn) => {
        btn.addEventListener('click',() => {
          self.closeModal();
        });
      });
      self.modal.addEventListener('focusout',self.closeModal);

      document.addEventListener('keyup',(e) => {
        if (e.key == "Escape") {
          self.closeModal();
        }
      });
    }

    addToLists(){
      const self = this;
      const checkedInputs = document.querySelectorAll('.customer-wishlist__input:checked');
      let listIDs = [];
      let listNames = [];
      checkedInputs.forEach((input) => {
        listIDs.push(input.value);
        listNames.push(input.dataset.name);
      });
      window._swat.addProductToLists(self.product, listIDs, function(){
        document.getElementById('wishlist-modal-success-lists').textContent = listNames.join(', ');
        self.modal.classList.add('success');
        const successTitle = document.querySelector('.wishlist-success__title');
        successTitle.setAttribute('tabindex','1');
        successTitle.focus();
        self.updateCustomerLists(function(){
          self.updateState();
        });
      }, self.addError);
    }

    createListForModal(name){
      const self = this;
      window._swat.createList({"lname": name}, function(newList){
        const checkboxHTML = self.listCheckbox(newList.lid,newList.lname);
        const newEl = document.createElement('div');
        newEl.innerHTML = checkboxHTML;
        document.getElementById('customer-wishlists').prepend(newEl);
        const newCheckbox = document.getElementById(`list-${newList.lid}`);
        self.initCheckboxEvent(newCheckbox,true);
        self.createInput.value = '';
        self.createBtn.setAttribute('disabled','disabled');

        self.updateCustomerLists(function(){
          if(swatCustomerLists.length >= 10){
            self.createWrapper.classList.add('hide');
          }
        });
      });
    }

    addError(error){
      console.error(error);
    }

    openModal(){
      this.modal.classList.remove('hide');
      hwTrapFocus(this.modal);
    }

    closeModal(){
      if(this.modal){
        hwCancelTrapFocus(this.modal);
        this.modal.remove();
        this.modal = null;
        this.addBtn = null;
        this.closeBtns = null;
        this.createWrapper = null;
        this.createInput = null;
        this.createBtn = null;
        this.createForm = null;
      }
      this.focus();
    }
  }
  function initWishlistButton(){
    customElements.define('wishlist-button', WishlistButton);
  }
});